import { Component, OnInit, Injectable  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { LoginService } from 'src/app/services/login.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { UsuariosService } from 'src/app/services/usuarios.service';

@Component({
  selector: 'app-general-portal-cliente',
  templateUrl: './general-portal-cliente.component.html',
  styleUrls: ['./general-portal-cliente.component.scss']
})
export class GeneralPortalClienteComponent implements OnInit {
  public id?: any;
  public params?: any
  public loggedUser: any
  documentos: any = []
  cliente: any

  constructor(private apollo: Apollo, private route: ActivatedRoute, private loginService: LoginService, private clienteService: ClienteService, private userService: UsuariosService) { 
    this.loggedUser = loginService.getUserData()
  console.log(this.loggedUser)}
    
  ngOnInit(){
  this.getClienteById()
  this.getUserLogged()
  }

  getClienteById(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.loggedUser.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
       this.cliente = data.cliente;
        
      })
  }
  
  getUserLogged(){
    this.apollo.watchQuery<any>({
      query: this.userService.getUsuariosById(),
      variables: {
        "id": this.loggedUser.id,
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loginService.setUserData(data.user)
       /*  this.loginService.setUserData(data.user) */

      })
  }


  

}
